import { useEffect, useRef } from 'react';
import useCustomHook from '@/hooks/useCustomHook';
import { useGamificationContext } from '@/shared/Gamification/GamificationContext/GamificationContext';

export default function useComicActivity({ activity, taskProgressActions }) {
  const gamificationContext = useGamificationContext();
  const lastGamificationCueSent = useRef('');

  const { state, actions } = useCustomHook({
    defaultState: {
      lastProgress: 0,
    },
    actions: {
      loadProgress: async () => {
        if (taskProgressActions) {
          await taskProgressActions.createProgress(
            {
              activityType: 'comic',
              progress: 0,
            },
            true
          );
        }
      },
      onActivityStart: async () => {
        console.log('Activity started!');
      },
      onActivityProgress: async (cue, cues) => {
        const prevPagesProgress = cue.pageId;

        const endPageTime = cues[0].end;
        const cueTime = cue.status == 'STARTING' ? cue.start : cue.end;
        const pageProgress = Math.min(cueTime / endPageTime, 1);

        const progress = Math.ceil(
          ((pageProgress + prevPagesProgress) / activity.data.pages.length) *
            100
        );

        if (
          cue.type == 'page' &&
          cue.status == 'ENDING' &&
          cue.id > lastGamificationCueSent.current
        ) {
          lastGamificationCueSent.current = cue.id;
          gamificationContext.actions.putData({
            activityId: activity.id,
            progress,
            correctAnswers: [`comic-page-${cue.pageId}`],
          });
        }

        if (taskProgressActions) {
          if (progress > state.lastProgress) {
            actions.setState({ lastProgress: progress });
            await taskProgressActions.updateProgress({
              activityType: 'comic',
              progress,
              currentCue: cue,
            });
          }
        }
      },
      onActivityRestart: async () => {
        lastGamificationCueSent.current = '';
        if (taskProgressActions) {
          taskProgressActions.onActivityRestarted();
          await taskProgressActions.createProgress({
            activityType: 'comic',
            progress: 0,
          });
        }
      },
    },
  });

  useEffect(() => {
    actions.loadProgress();
  }, []);

  return {
    state: {
      ...state,
      isGamificationStudent: gamificationContext.state.isGamificationStudent,
    },
    actions,
  };
}
